import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import './activitesSurPlace.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Lightbox from '../components/Lightbox';

const ActivitesSurPlace = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);


  return (
    <div className="activ-page">
      <Helmet>
        <title>Activités au sein du hameau | Le Hameau du Sorbier</title>
        <meta
          name="description"
          content="Découvrez les activités sur place au Hameau du Sorbier : piscine, terrain de pétanque, tennis de table, jeux de société et balades à pied ou à vélo."
        />
      </Helmet>


      <section className="activ-section bg-surplace" data-aos="fade-up">
        <div className="section-inner">
          <h1>Activités au sein du hameau</h1>

          <p className="section-intro">Détente, loisirs et moments à partager.</p>

        </div>
      </section>

     


     {/* --- Piscine & transats --- */}
      <section className="activ-section activ-flex reverse" data-aos="fade-up">
        <div className="activ-text">
          <h2>Piscine & transats</h2>
          <p>
            Profitez d’un espace extérieur paisible doté une piscine privative, des transats pour se relaxer au soleil, ainsi qu’un pool house offrant une zone ombragée. Un cadre idéal pour alterner lecture, baignade et sieste en toute sérénité.
            
          
          </p>
        </div>
        <div
          className="activ-image"
          style={{ backgroundImage: "url('/img/galerie/lamaison-exterieur/img5.jpg')" }}
        />
      </section>



      {/* --- Terrain de pétanque --- */}
      <section className="activ-section activ-flex" data-aos="fade-up">
        <div className="activ-text">
          <h2>Terrain de pétanque</h2>
          <p>
            Le terrain de pétanque ombragé vous attend pour des tournois
            improvisés et des apéros ensoleillés. Ambiance garantie !
          </p>
        </div>
        <div
          className="activ-image"
          style={{ backgroundImage: "url('/img/galerie/lamaison-exterieur/img12.jpg')" }}
        />
      </section>




      {/* --- Tennis de table --- */}
      <section className="activ-section activ-flex reverse" data-aos="fade-up">
        <div className="activ-text">
          <h2>Tennis de table</h2>
          <p>
           Une table de ping-pong est à votre disposition sous le préau, à l’abri du vent, afin de pouvoir jouer dans d’excellentes conditions à tout moment.
          </p>
        </div>
        <div
          className="activ-image"
          style={{ backgroundImage: "url('/img/pingpong.jpg')" }}
        />
      </section>




      {/* --- Salle de jeux & société --- */}
      <section className="activ-section activ-flex" data-aos="fade-up">
        <div className="activ-text">
          <h2>Jeux de société dans le fouril</h2>
          <p>
             Dans l’ancien fournil, découvrez un espace authentique dédié aux jeux de société et d'adresse, pour petits et grands. Un lieu idéal pour partager des moments de complicité en famille ou entre amis.

          </p>
        </div>
        <div
          className="activ-image"
          style={{ backgroundImage: "url('/img/galerie/lefour/img2.jpg')" }}
        />
      </section>





      {/* --- Moments de calme --- */}
      <section className="activ-section activ-flex reverse" data-aos="fade-up">
        <div className="activ-text">
          <h2>Moments de calme</h2>
          <p>
            Laissez-vous porter par le son des oiseaux, un livre à la main sous
            les arbres, ou une sieste dans un transat. Le hameau est pensé pour
            vous offrir un vrai temps de pause.
          </p>
        </div>
        <div
          className="activ-image"
          style={{ backgroundImage: "url('/img/galerie/lehameau/sansardoise.png')" }}
        />
      </section>




       {/* --- Couchers de soleil & nuits étoilées--- */}
      <section className="activ-section activ-flex" data-aos="fade-up">
        <div className="activ-text">
          <h2>Couchers de soleil & nuits étoilées</h2>
          <p>
             En fin de journée, la piscine devient un point de vue privilégié pour admirer le coucher de soleil, avant que la nuit ne révèle un ciel étoilé d’une grande pureté, loin de toute pollution lumineuse. Le hameau est pensé comme une parenthèse hors du temps, idéale pour s’accorder un véritable moment de pause.
          </p>
        </div>
        <div
          className="activ-image"
          style={{ backgroundImage: "url('/img/galerie/lehameau/img17.jpg')" }}
        />
      </section>


       


      

    

    

      

      {/* --- Billard (coming soon) --- */}
      {/* <section className="activ-section activ-flex reverse" data-aos="fade-up">
        <div className="activ-text">
          <h2>
            Billard <span className="coming-soon">– prochainement !</span>
          </h2>
          <p>
            Un nouvel espace détente avec billard sera bientôt disponible dans
            une dépendance restaurée. À venir pour la saison prochaine !
          </p>
        </div>
        <div
          className="activ-image"
          style={{ backgroundImage: "url('/img/billard.jpg')" }}
        />
      </section> */}

      {/* --- Balades à pied ou à vélo --- */}
      <section className="activ-section circuits-section" data-aos="fade-up">
        <h2>Balades à pied ou à VTT</h2>
        <p>
          Depuis le hameau, partez explorer la nature environnante grâce à nos
          circuits disponibles sur l’application Komoot, dont toutes les boucles démarrent directement du hameau. 
          Que vous soyez amateur de promenades tranquilles ou sportif aguerri, chacun y trouvera son bonheur.
        </p>

        <div className="circuit-categories">
          {/* FAMILIAL */}
          <div className="circuit-block" data-aos="fade-up">
            <h3>Parcours familiaux</h3>

            <div className="circuit-gallery">
              {/* Carte 1 */}
              <div className="circuit-card">
                <img
                  src="/Boucles/5-10/5-10_12.png"
                  alt="Circuit familial 1"
                  onClick={() => setSelectedImage("/Boucles/5-10/5-10_12.png")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/fam1_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/fam1_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/fam1_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>

              {/* Carte 2 */}
              <div className="circuit-card">
                <img
                  src="/img/circuit-fam2.jpg"
                  alt="Circuit familial 2"
                  onClick={() => setSelectedImage("/img/circuit-fam2.jpg")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/fam2_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/fam2_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/fam2_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>

              {/* Carte 3 */}
              <div className="circuit-card">
                <img
                  src="/img/circuit-fam3.jpg"
                  alt="Circuit familial 3"
                  onClick={() => setSelectedImage("/img/circuit-fam3.jpg")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/fam3_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/fam3_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/fam3_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* INTERMÉDIAIRE */}
          <div className="circuit-block" data-aos="fade-up">
            <h3>Parcours intermédiaires</h3>

            <div className="circuit-gallery">
              {/* Carte 1 */}
              <div className="circuit-card">
                <img
                  src="/img/circuit-inter1.jpg"
                  alt="Circuit intermédiaire 1"
                  onClick={() => setSelectedImage("/img/circuit-inter1.jpg")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/inter1_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/inter1_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/inter1_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>

              {/* Carte 2 */}
              <div className="circuit-card">
                <img
                  src="/img/circuit-inter2.jpg"
                  alt="Circuit intermédiaire 2"
                  onClick={() => setSelectedImage("/img/circuit-inter2.jpg")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/inter2_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/inter2_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/inter2_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>

              {/* Carte 3 */}
              <div className="circuit-card">
                <img
                  src="/img/circuit-inter3.jpg"
                  alt="Circuit intermédiaire 3"
                  onClick={() => setSelectedImage("/img/circuit-inter3.jpg")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/inter3_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/inter3_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/inter3_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* SPORTIF */}
          <div className="circuit-block" data-aos="fade-up">
            <h3>Parcours sportifs</h3>

            <div className="circuit-gallery">
              {/* Carte 1 */}
              <div className="circuit-card">
                <img
                  src="/img/circuit-sport1.jpg"
                  alt="Circuit sportif 1"
                  onClick={() => setSelectedImage("/img/circuit-sport1.jpg")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/sport1_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/sport1_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/sport1_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>

              {/* Carte 2 */}
              <div className="circuit-card">
                <img
                  src="/img/circuit-sport2.jpg"
                  alt="Circuit sportif 2"
                  onClick={() => setSelectedImage("/img/circuit-sport2.jpg")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/sport2_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/sport2_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/sport2_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>

              {/* Carte 3 */}
              <div className="circuit-card">
                <img
                  src="/img/circuit-sport3.jpg"
                  alt="Circuit sportif 3"
                  onClick={() => setSelectedImage("/img/circuit-sport3.jpg")}
                />
                <div className="circuit-links">
                  <a
                    className="circuit-link circuit-red"
                    href="/kml/sport3_rouge.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rouge
                  </a>
                  <a
                    className="circuit-link circuit-blue"
                    href="/kml/sport3_bleu.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bleu
                  </a>
                  <a
                    className="circuit-link circuit-green"
                    href="/kml/sport3_vert.kml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Vert
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox plein écran */}
      <Lightbox image={selectedImage} onClose={() => setSelectedImage(null)} />
    </div>
  );
};

export default ActivitesSurPlace;
